import { deserialize, serialize, inheritSerialization } from "cerialize";
import BaseEntity from "../BaseEntity";
import TableColumn from "../TableColumn";
import { getVm } from "@/util/GlobalVm";

@inheritSerialization(BaseEntity)
export default class TUKMasterIncome extends BaseEntity {
    @serialize
    @deserialize
    public nama: string = "";

    @serialize
    @deserialize
    public kode: string = "";

    @serialize
    @deserialize
    public is_active: boolean = true;

    public table(): any {
        return {
            nama: this.nama,
            kode: this.kode,
            is_active: this.is_active
        };
    }

    public static columnName(): Array<any> {
        const config = new TUKMasterIncome().table();
        let keys = Object.keys(config);

        return keys.map((field: any) => {
            const tableColumn = new TableColumn();
            tableColumn.name = getVm().$t(`label.${field}`);
            if (field === 'is_active' || field === 'kode') {
                tableColumn.position = 'centered';
            }
            return tableColumn;
        });
    }
}
